
export const projects = [
  // {
  //   title: "React Reserve",
  //   subtitle: "MERN Stack",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
  //   image: "./project-1.gif",
  //   link: "https://reactbootcamp.com",
  // },
  // {
  //   title: "React Tracks",
  //   subtitle: "React and Python",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
  //   image: "./project-2.gif",
  //   link: "https://reactbootcamp.com",
  // },
  {
    title: "Covid Tracker Webapp",
    subtitle: "HTML/CSS & JavaScript",
    description:
      "Covid Tracker Website for better Analysis of Covid Data Country Wise. Location can be changed dynamically to obtain the real time data which using the open source api calls..",
    image: "./project-2.gif",
    link: "https://19trackercovid.netlify.app/",
  },
  {
    title: "Vartalaap - Basic Chat Room Webapp",
    subtitle: "Django, Python, and JavaScript",
    description:
      "Vartalaap is a simple chat webapp where users can created on the admin end & they can join a certain conversation group but it is limited to just one domain..",
    image: "./project-3.gif",
    link: "",
  },
  {
    "title": "Portfolio Showcase",
    "subtitle": "React.js Web Application",
    "description": "Portfolio Showcase is a React.js web application designed to display and highlight the my work and skills. ",
    "image": "./project-4.gif",
    "link": "https://cyborglaksh.github.io/myportfolio/"
  }
  
];

// export const testimonials = [
//   {
//     quote:
//       "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
//     image: "https://randomuser.me/api/portraits/men/1.jpg",
//     name: "Jesse Hicks",
//     company: "Zoozle",
//   },
//   {
//     quote:
//       "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
//     image: "https://randomuser.me/api/portraits/men/94.jpg",
//     name: "Ruben Alvarez",
//     company: "Dooble.io",
//   },
// ];

export const skills = [
  "JavaScript",
  "React.js",
  "Node.js",
  "Python",
  "Django",
  "Ansible",
  "Golang",
  "C++",
  "HTML/CSS",
  "Docker",
];

export const socials = [
  { 
    name: "Github",
    url: 'https://github.com/cyborglaksh', 
    icon: 'https://simpleicons.org/icons/github.svg', 
  },
  { 
    name: "Linkedin",
    url: 'https://www.linkedin.com/in/cyborglaksh/', 
    icon: 'https://simpleicons.org/icons/linkedin.svg',
  },  
  { 
    name: "Dev.to",
    url: 'https://dev.to/cyborglaksh', 
    icon: 'https://simpleicons.org/icons/devdotto.svg',
  },
  // Add more social links as needed
];

export const workex = [
  {
    Company: "Microland",
    Position: "Software Developer",
    Description: "Specializing in development, my stack includes Python, Django, Golang, and Kotlin. Initially focusing on Ansible automation and Grafana deployment, I later transitioned to the End User Platforms team at Microland. Here, I developed, tested, and deployed Windows-specific bots to elevate customer environments and enhance end-user experiences.",
    Order: "1",
    time: "2022-Present",
  },
  {
    Company: "Microland",
    Position: "Engineer Intern",
    Description: "Developed MongoDB-driven UI for seamless data extraction with CRUD operations, deployed via internal servers. Integrated RBAC into user creation model. Designed and developed real-time IDE creation. Enhanced data update flow with Django-based UI, automating workflow and minimizing manual effort and execution time.",
    Order: "2",
    time: "2022",
  },
  {
    Company: "Axis Bank",
    Position: "Summer Engineer Intern",
    Description: "Developed a Covid-19 tracker website inclusive of search via queries based mechanism.Visualization of Covid data for different countries using graphs.Developed the automation pipeline for Code using CICD pipelines in SDLC with the help of Jenkins CI Tool. Used Github as Source Code Repo and deployed the project into production and reduced manual labour.",
    Order: "3",
    time: "2021"
  },
];


// export const honors = [];



// WEBPACK FOOTER //
// ./src/data.js